export function initScrollTopButton() {
    const scrollTop = document.getElementById('scrollTop');
    const scrollTopButton = scrollTop.querySelector(".js-scroll-top-button");
    const footer = document.querySelector("footer"); // or use "#footer" if it has an ID
    if (!scrollTop || !scrollTopButton || !footer) return;

    let sizeAllowed = false;
    let footerInView = false;
    window.addEventListener('scroll', () => {
        const scrollDistanceTop = document.scrollingElement.scrollTop; // modern way

        if (sizeAllowed && !footerInView && scrollDistanceTop > window.innerHeight) {
            scrollTop.classList.add('in-view');
        } else {
            scrollTop.classList.remove('in-view');

        }
    });
    scrollTopButton.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    const heightObserver = new ResizeObserver(() => {
        const windowHeight = window.innerHeight;
        const scrollHeight = document.documentElement.scrollHeight;
        sizeAllowed = scrollHeight >= 2 * windowHeight;
    });

// Create the observer
    const footerObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            footerInView = entry.isIntersecting;
        });
    }, {
        root: null,       // null = viewport
        threshold: 0.1    // 0 = as soon as even 1px is visible, 1 = fully visible
    });

    footerObserver.observe(footer);
    heightObserver.observe(document.body);

}
